import { render, staticRenderFns } from "./GridIntroDialog.vue?vue&type=template&id=50e12ff5"
import script from "./GridIntroDialog.vue?vue&type=script&lang=js"
export * from "./GridIntroDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports